import { render, staticRenderFns } from "./VSocialShare.vue?vue&type=template&id=3cbec789"
import script from "./VSocialShare.vue?vue&type=script&lang=js"
export * from "./VSocialShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../home/michael/.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports